import * as React from "react";


export const AuthContext = React.createContext({
    isAuthenticated: false,
    login: () => {},
    logout: () => {}
});

const AuthProvider : React.FunctionComponent<{}> = (props:any) => {

    const [isAuthenticated, setAuthenticated] = React.useState(false);

    const login = () => {
        setAuthenticated(true);
    }
    const logout = () => {
        setAuthenticated(false);
    }

    return (
        <AuthContext.Provider value={{isAuthenticated: isAuthenticated, login: login, logout: logout}}>{props.children}</AuthContext.Provider>
    );
};

export {AuthProvider as default};


export function AuthConsumer() {
    return React.useContext(AuthContext);
}
